import { ACTION_LOGOUT } from "@login/reducer/actions.type";
import {
  SET_AUTO_BILLING_STORE,
  SET_AUTO_BILLING_RESET,
  FETCH_AUTO_BILLING_LIST_REQUEST,
  FETCH_AUTO_BILLING_LIST_SUCCESS,
  FETCH_AUTO_BILLING_LIST_FAILURE,
  FETCH_AUTO_BILLING_DELETE_REQUEST,
  FETCH_AUTO_BILLING_DELETE_SUCCESS,
  FETCH_AUTO_BILLING_DELETE_FAILURE,
  FETCH_AUTO_BILLING_VALID_CUSTOMER_REQUEST,
  FETCH_AUTO_BILLING_VALID_CUSTOMER_SUCCESS,
  FETCH_AUTO_BILLING_VALID_CUSTOMER_FAILURE,
  FETCH_AUTO_BILLING_CREATE_REQUEST,
  FETCH_AUTO_BILLING_CREATE_SUCCESS,
  FETCH_AUTO_BILLING_CREATE_FAILURE,
  FETCH_AUTO_BILLING_AUTHORIZATION_KEY_REQUEST,
  FETCH_AUTO_BILLING_AUTHORIZATION_KEY_SUCCESS,
  FETCH_AUTO_BILLING_AUTHORIZATION_KEY_FAILURE,
  FETCH_AUTO_BILLING_TRANSACTION_REQUEST,
  FETCH_AUTO_BILLING_TRANSACTION_SUCCESS,
  FETCH_AUTO_BILLING_TRANSACTION_FAILURE,
} from "./actions.type";

import { AutoBillingState, AutoBillingActions } from "./types";

const initialState: AutoBillingState = {
  statusListAuto: "init",
  responseListAutoBilling: undefined,
  resDelete: undefined,
  statusDelete: "init",
  responseValidCustomer: undefined,
  dataCreate: undefined,
  responseCreate: undefined,
  responseAuth: undefined,
  isCreated: false,
  isAuthorization: false,
  errorOTP: false,
  responseTransaction: undefined,
  statusTransaction: "init",
  statusCreate: "init",
  statusAuth: "init",
  errorMsg: undefined,
};

export default (state = initialState, action: AutoBillingActions): AutoBillingState => {
  switch (action.type) {
    case FETCH_AUTO_BILLING_LIST_REQUEST:
      return {
        ...state,
        statusListAuto: "pending",
      };
    case FETCH_AUTO_BILLING_LIST_SUCCESS:
      return {
        ...state,
        statusListAuto: "ok",
        responseListAutoBilling: action.payload,
      };
    case FETCH_AUTO_BILLING_LIST_FAILURE:
      return {
        ...state,
        statusListAuto: "error",
      };
    case FETCH_AUTO_BILLING_DELETE_REQUEST:
      return {
        ...state,
        resDelete: undefined,
        statusDelete: "pending",
      };
    case FETCH_AUTO_BILLING_DELETE_SUCCESS:
      return {
        ...state,
        resDelete: action.payload,
        statusDelete: "ok",
      };
    case FETCH_AUTO_BILLING_DELETE_FAILURE:
      return {
        ...state,
        statusDelete: "error",
      };
    case FETCH_AUTO_BILLING_VALID_CUSTOMER_REQUEST:
      return {
        ...state,
        dataCreate: action.payload,
        responseValidCustomer: undefined,
        errorMsg: undefined,
      };
    case FETCH_AUTO_BILLING_VALID_CUSTOMER_SUCCESS:
      return {
        ...state,
        responseValidCustomer: action.payload,
      };
    case FETCH_AUTO_BILLING_VALID_CUSTOMER_FAILURE:
      return {
        ...state,
        responseValidCustomer: 'error',
        errorMsg: action.payload,
      };
    case FETCH_AUTO_BILLING_CREATE_REQUEST:
      return {
        ...state,
        responseCreate: undefined,
        isCreated: false,
        statusCreate: "pending",
        errorMsg: undefined,
      };
    case FETCH_AUTO_BILLING_AUTHORIZATION_KEY_REQUEST:
      return {
        ...state,
        responseAuth: undefined,
        isAuthorization: false,
        statusAuth: "pending",
        errorMsg: undefined,
      };
    case FETCH_AUTO_BILLING_CREATE_FAILURE:
      return {
        ...state,
        statusCreate: "error",
      };
    case FETCH_AUTO_BILLING_AUTHORIZATION_KEY_FAILURE:
      return {
        ...state,
        errorOTP: action.errorOTP,
        errorMsg: action.payload,
        statusAuth: "error",
      };
    case FETCH_AUTO_BILLING_CREATE_SUCCESS:
      return {
        ...state,
        isCreated: true,
        responseCreate: action.payload,
        statusCreate: "ok",
      };
    case FETCH_AUTO_BILLING_AUTHORIZATION_KEY_SUCCESS:
      return {
        ...state,
        responseAuth: action.payload,
        isAuthorization: true,
        statusAuth: "ok",
      };
    case FETCH_AUTO_BILLING_TRANSACTION_REQUEST:
      return {
        ...state,
        responseTransaction: undefined,
        statusTransaction: "pending",
      };
    case FETCH_AUTO_BILLING_TRANSACTION_SUCCESS:
      return {
        ...state,
        responseTransaction: action.payload,
        statusTransaction: "ok",
      };
    case FETCH_AUTO_BILLING_TRANSACTION_FAILURE:
      return {
        ...state,
        statusTransaction: "error",
      };
    case SET_AUTO_BILLING_STORE:
      return {
        ...state,
        ...action.payload,
      };
    case SET_AUTO_BILLING_RESET:
      return {
        ...initialState,
      };
    case ACTION_LOGOUT:
      return {
        ...initialState,
      };
    default:
      return {
        ...state,
      };
  }
};
